import { Stack } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';

export const StarRating = (props: { rating: number }) => {
  const { rating } = props;

  return (
    <Stack sx={{ gap: 1, flexDirection: 'row' }}>
      {Array.from({ length: rating }, (_, i) => (
        <StarIcon sx={{ color: 'white', fontSize: 16 }} key={i} />
      ))}
    </Stack>
  );
};
